:host {
  display: block;
  --sy-dialog-size-md: 398px;
  --sy-dialog-content-padding-bottom: 24px;
  --sy-dialog-content-padding-left: 24px;
  --sy-dialog-content-padding-right: 24px;

  .dialog-content {
    text-align: center;
    margin-bottom: 24px;

    sy-text[type="h4"] {
      margin-bottom: 4px;
    }

    sy-text[type="body"] {
      color: #495057;
    }
  }
}
